import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({
  title = "Ready for a genuinely spotless clean?",
  subtitle = "Get a free, no-obligation quote today. Simple, honest pricing across the Gold Coast.",
  primaryHref = "/contact",
  primaryLabel = "Get a Free Quote",
}) {
  return (
    <section
      className="relative py-24 sm:py-32 bg-[#0A0A0B] overflow-hidden grain"
      data-testid="cta-section"
    >
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#C9A24B]/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#C9A24B]/5 blur-3xl" />
      </div>
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <span className="eyebrow">Book your clean</span>
        <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
          {title}
        </h2>
        <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-2xl mx-auto">
          {subtitle}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={primaryHref} className="btn-primary" data-testid="cta-primary-button">
            {primaryLabel} <ArrowRight size={16} />
          </Link>
          <a href="tel:0416238430" className="btn-outline" data-testid="cta-call-button">
            Call 0416 238 430
          </a>
        </div>
      </div>
    </section>
  );
}
